import { ReactElement } from 'react';

function ReviewAddressModal(): ReactElement {
  return (
    <>
      <div>
        <h4>Change of address? Remember to update your details with VicRoads</h4>
        <p>Have you moved recently? By law you must advise VicRoads of your new address within 14 days of moving.</p>
        <p>Fines sent to the address registered with VicRoads are 'deemed served', even if you no longer live there and did not receive them.</p>
        <p>This means that agencies can take enforcement action against you if you have not dealt with a fine sent to an old address.</p>
        <p>You can update both your licence and vehicle registration details online at VicRoads.</p>
        <div style={{ padding: '17px', margin: 'auto', width: '100%', textAlign: 'center' }}>
          <a
            style={{
              padding: '17px 32px',
              transition: 'all 0.5s ease',
              borderRadius: '2px',
              fontWeight: 600,
              fontFamily: 'VIC',
              textDecoration: 'none',
              display: 'inline-block',
              backgroundColor: '#00a9e1',
              border: '1px solid #00a9e1',
              textAlign: 'center',
            }}
            href="https://www.vicroads.vic.gov.au/licences/renew-replace-or-update/update-your-details/change-of-address"
            target="_blank"
            rel="noreferrer">
            Go to VicRoads
          </a>
        </div>
      </div>
    </>
  );
}

export default ReviewAddressModal;
